import React, { useEffect, useState } from 'react'
import Button from '../../ui/Button/Button'
import { createForm } from '../../utils/newforms/createForm'
import getFieldRenderObject from '../../utils/newforms/render/getFieldRenderObject'
import FormRender from '../../utils/newforms/render/FormRender'
import getFormValues from '../../utils/newforms/getFormValues'
import './Customers.sass'

class CustomersFiltersForm {
  constructor() {
    this.name = {
      field: {
        fieldId: 'name',
        fieldType: 'input',
        type: 'text',
        label: 'ПІБ',
        required: false,
      },
      render: getFieldRenderObject(),
    }
    this.phone = {
      field: {
        fieldId: 'phone',
        fieldType: 'input',
        type: 'text',
        label: 'Телефон',
        required: false,
      },
      render: getFieldRenderObject(),
    }
    this.createdFromDate = {
      field: {
        fieldId: 'createdFromDate',
        fieldType: 'date',
        label: 'Реєстрація від',
        required: false,
      },
      render: getFieldRenderObject(),
    }
    this.createdToDate = {
      field: {
        fieldId: 'createdToDate',
        fieldType: 'date',
        label: 'Реєстрація до',
        required: false,
      },
      render: getFieldRenderObject(),
    }
    this.registrationChannel = {
      field: {
        fieldId: 'registrationChannel',
        fieldType: 'select',
        label: 'Джерело реєстрації',
        required: false,
        getOptions: [
          { value: '', label: 'Усі джерела' },
          { value: 'storefront', label: 'Сайт' },
          { value: 'offline_store', label: 'Офлайн-магазин' },
          { value: 'unknown', label: 'Не визначено' },
        ],
      },
      render: getFieldRenderObject(),
    }
  }
}

const formDataFromFilters = (filters) => ({
  name: filters.name || '',
  phone: filters.phone || '',
  createdFromDate: filters.createdFromDate || '',
  createdToDate: filters.createdToDate || '',
  registrationChannel: filters.registrationChannel || '',
})

const filtersFromForm = (form) => {
  const values = getFormValues({ form })
  return {
    name: values.name || '',
    phone: values.phone || '',
    createdFromDate: values.createdFromDate || '',
    createdToDate: values.createdToDate || '',
    registrationChannel: values.registrationChannel || '',
  }
}

function CustomersFilters({ filters, onChange, onApply, onReset, formKey = 0 }) {
  const [form, setForm] = useState(null)

  useEffect(() => {
    setForm(
      createForm({
        formPattern: new CustomersFiltersForm(),
        formData: formDataFromFilters(filters),
      })
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formKey])

  const setFormAndSync = (updater) => {
    setForm((prev) => {
      if (!prev) return prev
      const next = typeof updater === 'function' ? updater(prev) : updater
      onChange(filtersFromForm(next))
      return next
    })
  }

  return (
    <div className="CustomersFilters">
      <div className="CustomersFilters-Fields">
        <FormRender
          sections={[{ fields: ['name', 'phone', 'createdFromDate', 'createdToDate', 'registrationChannel'] }]}
          form={form}
          setForm={setFormAndSync}
          errors={false}
        />
        <div className="CustomersFilters-Actions">
          <Button
            title="Застосувати"
            theme="solid"
            fill="accent"
            size={32}
            onClick={() => {
              if (!form) return
              const next = filtersFromForm(form)
              onChange(next)
              onApply(next)
            }}
          />
          <Button title="Скинути" theme="solid" fill="normal" size={32} onClick={onReset} />
        </div>
      </div>
    </div>
  )
}

export default CustomersFilters
